import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: 'SearchSelect',
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String
    },
    size: {
      type: String,
      default: 'large'
    },
    options: {
      type: Array,
      default: []
    }
  },
  setup: function setup(_, _ref) {
    var emit = _ref.emit;

    var onSearchTextChange = function onSearchTextChange(e) {
      emit('search', e.target.value);
      emit('update:value', e.target.value);
    };

    var onItemSelect = function onItemSelect(item) {
      current.value = [item.key];
      emit('select', item.key);
    };

    var current = ref([]);
    return {
      onSearchTextChange: onSearchTextChange,
      onItemSelect: onItemSelect,
      current: current
    };
  }
});